import styled from "@emotion/styled";
import { FC, HTMLProps, PropsWithChildren } from "react";
import { Dialog, Modal, ModalOverlayProps } from "react-aria-components";
import { PopupDialogCloseButton } from "./PopupDialogCloseButton";
import { IconDialogClose } from "../../../icons/IconDialogClose"; // Don't change this. `icons` folder is outside `src` -> results in a type check error without the dots

const StyledModal = styled(Modal)`
  --popup-dialog-width: 342px;
  flex: 0 0 var(--popup-dialog-width);
  border-radius: 24px;
  background-color: var(--color-white);
  padding: 0;
  text-align: left;
  font-family: "STK Bureau", Sans-Serif, sans-serif;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

const StyledDialog = styled(Dialog)`
  position: relative;
`;

export const PopupDialog: FC<
  ModalOverlayProps & PropsWithChildren<HTMLProps<HTMLDivElement>>
> = ({ children, ...props }) => {
  return (
    <StyledModal {...props}>
      <StyledDialog>
        <PopupDialogCloseButton slot={"close"}>
          <IconDialogClose />
        </PopupDialogCloseButton>
        {children}
      </StyledDialog>
    </StyledModal>
  );
};
